import { EnumMethod } from "@/constant/app";
import { endpoints } from "../redux/features/endpoints";
import { EndpointSetting, EnumReduces, TypeServices } from "../redux/type";
import baseAxios from "./baseAxios";
import { getStringParams } from "@/utils/string/getStringParams";
import { serialize } from "object-to-formdata";

export const services: TypeServices = Object.values(EnumReduces).reduce(
  (servicesReduced: any, reducerName) => {
    const endpointsOfReducer = Object.entries((endpoints || {})[reducerName] || {})

    for (let i = 0; i < endpointsOfReducer.length; i++) {
      const [endpointName, endpointSetting] = endpointsOfReducer[i] as [string, EndpointSetting];

      servicesReduced[endpointName] = async ({ params: _params, body: _body }: { params: any, body?: any }, headers?: any) => {
        let response,
          { customEndpoint, ...params } = _params || {},
          { TYPE, ...body } = _body || {}
        let endpoint = customEndpoint ? customEndpoint(endpointSetting.endpoint) : endpointSetting.endpoint
        let _headers = { ...headers }
        const isJson = TYPE === 'JSON'

        if (isJson) {
          _headers['Content-Type'] = 'application/json'
        }

        if (endpointSetting.callerService) {
          response = await endpointSetting.callerService(body)
        } else {
          switch (endpointSetting.method) {
            case EnumMethod.GET:
              response = await baseAxios(endpointSetting.api).get(endpoint, { params, headers: _headers })
              break;
            case EnumMethod.DEL:
              response = await baseAxios(endpointSetting.api).delete(endpoint, { params, headers: _headers })
              break;
            case EnumMethod.POST:
              response = await baseAxios(endpointSetting.api).post(
                endpoint + getStringParams(params), 
                isJson ? JSON.stringify(body) : serialize(body), 
                { headers: _headers }
              )
              break;
            case EnumMethod.PUT:
              response = await baseAxios(endpointSetting.api).put(
                endpoint + getStringParams(params), 
                isJson ? JSON.stringify(body) : serialize(body), 
                { headers: _headers }
              )
              break;
  
            default:
              break;
          }
        }
        
        return response
      }
    }

    return servicesReduced
  },
  {} as TypeServices
)